import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { CAAReportList } from '../../domain/models/CAAReport'
import { CAAResponse } from '../../domain/models/CAAResponse'
import { CAADatasource } from '../../infra/datasources/CAADatasource'

export const caaDatasourceAdapter: CAADatasource = {
  async listCAAForOperational({
    date,
    patientId,
    personaName,
    availability,
    typeCAA
  }) {
    const urlSearchParams = new URLSearchParams()
    urlSearchParams.append('date', date)
    if (patientId) urlSearchParams.append('patientId', patientId)
    if (personaName) urlSearchParams.append('personaName', personaName)
    if (availability) urlSearchParams.append('availability', availability)
    if (typeCAA) urlSearchParams.append('typeCAA', typeCAA)

    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/caa?${urlSearchParams.toString()}`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )

    return CAAResponse.parse(await response.json())
  },

  async listCAAForManagers({
    date,
    patientId,
    personaName,
    availability,
    typeCAA
  }) {
    const urlSearchParams = new URLSearchParams()
    urlSearchParams.append('date', date)
    if (patientId) urlSearchParams.append('patientId', patientId)
    if (personaName) urlSearchParams.append('personaName', personaName)
    if (availability) urlSearchParams.append('availability', availability)
    if (typeCAA) urlSearchParams.append('typeCAA', typeCAA)

    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/managers/caa?${urlSearchParams.toString()}`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )

    return CAAResponse.parse(await response.json())
  },

  listDateCAAReport: async function (patientId, date) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-date-caa?date=${date}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = CAAReportList.parse(await response.json())
    return json
  },
  listWeekCAAReport: async function (patientId, date) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-week-caa?date=${date}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = CAAReportList.parse(await response.json())
    return json
  },
  listMonthCAAReport: async function (patientId, month, year) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-month-caa?month=${month}&year=${year}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = CAAReportList.parse(await response.json())
    return json
  },
  listSemesterCAAReport: async function (patientId, year, semester) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-semester-caa?period=${semester}&year=${year}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = CAAReportList.parse(await response.json())
    return json
  },
  listCustomCAAReport: async function (patientId, startDate, endDate) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-custom-caa?startDate=${startDate}&endDate=${endDate}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = CAAReportList.parse(await response.json())
    return json
  }
}
